import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

/** Represents the view public.sensor_with_calibration_count_view_ */
export default interface SensorWithCalibrationCountViewTable {
  /** Database type: pg_catalog.text */
  sensorId: ColumnType<string, never, never>

  /** Database type: pg_catalog.int8 */
  calibrationCount: ColumnType<string, never, never>

  /** Database type: pg_catalog.timestamptz */
  lastCalibrationDate: ColumnType<Date, never, never>

  /** Database type: pg_catalog.timestamptz */
  firstCalibrationCreatedAt: ColumnType<Date, never, never>

  /** Database type: pg_catalog.timestamptz */
  lastCalibrationCreatedAt: ColumnType<Date, never, never>
}

export type SensorWithCalibrationCountView =
  Selectable<SensorWithCalibrationCountViewTable>

export const sensorWithCalibrationCountView = z.object({
  sensorId: z.string(),
  calibrationCount: z.string(),
  lastCalibrationDate: z.coerce.date(),
  firstCalibrationCreatedAt: z.coerce.date(),
  lastCalibrationCreatedAt: z.coerce.date(),
}) as unknown as z.Schema<SensorWithCalibrationCountView>
